import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { BrowserRouter } from 'react-router-dom';
import { Global, css } from '@emotion/react';
import Layout from './components/Layout';
import { SiteDataProvider } from './context/SiteDataContext';
const globalStyles = css `
  :root {
    --mc-red: #e51e2b;
    --mc-red-dark: #C40000;
    --mc-yellow: #e51e2b;
    --mc-yellow-hot: #ff3a45;
    --mc-black: #0c1114;
    --mc-black-pure: #080b0d;
    --mc-white: #FFFFFF;
    --mc-surface: #f5f5f5;
    --mc-ink: #0c1114;
    --yellow: #e51e2b;
    --ink: #0c1114;
    --paper: #f5f5f5;
  }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html {
    scroll-behavior: smooth;
    scroll-padding-top: 110px;
    overflow-x: clip;
    -webkit-text-size-adjust: 100%;
    padding-left: env(safe-area-inset-left, 0px);
    padding-right: env(safe-area-inset-right, 0px);
  }
  html, body, #root {
    background-color: var(--mc-surface);
    min-width: 0;
    max-width: 100vw;
  }
  body {
    font-family: 'Inter', 'Lato', Arial, sans-serif;
    line-height: 1.6;
    color: #10161a;
    -webkit-font-smoothing: antialiased;
    overflow-x: clip;
    text-rendering: optimizeLegibility;
  }
  #root {
    isolation: isolate;
  }
  img { max-width: 100%; height: auto; display: block; }
  iframe { max-width: 100%; }
  a { color: inherit; text-decoration: none; }
  button:focus-visible, a:focus-visible, input:focus-visible, select:focus-visible {
    outline: 3px solid var(--mc-red); outline-offset: 2px;
  }
  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;
const App = () => (_jsxs(_Fragment, { children: [_jsx(Global, { styles: globalStyles }), _jsx(BrowserRouter, { basename: process.env.ROUTER_BASENAME || undefined, children: _jsx(SiteDataProvider, { children: _jsx(Layout, {}) }) })] }));
export default App;
